<script setup lang="ts">
// Outline office building with a doorway — the Figma property-row glyph
// (Sell Request list). Stroke-based, so it tints via CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    stroke-width="1.33333"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path d="M3.33333 17.5H16.6667" />
    <path
      d="M5 17.5V5C5 4.55797 5.17559 4.13405 5.48816 3.82149C5.80072 3.50893 6.22464 3.33333 6.66667 3.33333H13.3333C13.7754 3.33333 14.1993 3.50893 14.5118 3.82149C14.8244 4.13405 15 4.55797 15 5V17.5"
    />
    <path d="M7.91667 6.66667H8.75" />
    <path d="M11.25 6.66667H12.0833" />
    <path d="M7.91667 10H8.75" />
    <path d="M11.25 10H12.0833" />
    <path
      d="M8.33333 17.5V14.5833C8.33333 14.1413 8.50893 13.7174 8.82149 13.4048C9.13405 13.0923 9.55797 12.9167 10 12.9167C10.442 12.9167 10.8659 13.0923 11.1785 13.4048C11.4911 13.7174 11.6667 14.1413 11.6667 14.5833V17.5"
    />
  </svg>
</template>
